import MainIntro from './MainIntro';
import HowDoesItWork from './HowDoesItWork';
import Features from './Features';
import Samples from './Samples';
import GetStarted from './GetStarted';
import { useEffect } from 'react';

export default function OriginPage(props) {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    return (
        <>       
            <MainIntro id="main-intro" />
            <HowDoesItWork id="how-it-works" />
            <Features id="pricing" />
            <Samples 
                id="samples"
            />
            <GetStarted 
                id="get-started" 
                navigateToSignup={props.navigateToSignup}
                navigateToGiveGift={props.navigateToGiveGift}
            />
        </>  
    )
}